var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "customer-data" },
    [
      _vm.isBilling
        ? [
            _c("div", { staticClass: "customer-data__item" }, [
              _vm._v(_vm._s(_vm.customerDataDTO.company)),
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "customer-data__item" },
              [
                _vm.customerDataDTO.title
                  ? [
                      _vm._v(
                        "\n        " + _vm._s(_vm.titleDisplay) + "\n      "
                      ),
                    ]
                  : _vm._e(),
                _vm._v(
                  "\n      " +
                    _vm._s(_vm.customerDataDTO.firstName) +
                    "\n      " +
                    _vm._s(_vm.customerDataDTO.lastName) +
                    "\n    "
                ),
              ],
              2
            ),
            _vm._v(" "),
            _c("div", { staticClass: "customer-data__item" }, [
              _vm._v(
                "\n      " +
                  _vm._s(_vm.customerDataDTO.street) +
                  "\n      " +
                  _vm._s(_vm.customerDataDTO.houseNr) +
                  "\n    "
              ),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "customer-data__item" }, [
              _vm._v(
                "\n      " +
                  _vm._s(_vm.customerDataDTO.zip) +
                  "\n      " +
                  _vm._s(_vm.customerDataDTO.city) +
                  "\n    "
              ),
            ]),
            _vm._v(" "),
            _c("br"),
            _vm._v(" "),
            _vm.customerDataDTO.country && !_vm.isGermany
              ? [
                  _c("div", { staticClass: "customer-data__item" }, [
                    _vm._v(_vm._s(_vm.countryDisplay)),
                  ]),
                ]
              : _vm._e(),
          ]
        : [
            _c(
              "div",
              { staticClass: "customer-data__item" },
              [
                _vm.customerDataDTO.title
                  ? [
                      _vm._v(
                        "\n        " + _vm._s(_vm.titleDisplay) + "\n      "
                      ),
                    ]
                  : _vm._e(),
                _vm._v(
                  "\n      " +
                    _vm._s(_vm.customerDataDTO.firstName) +
                    "\n      " +
                    _vm._s(_vm.customerDataDTO.lastName) +
                    "\n    "
                ),
              ],
              2
            ),
            _vm._v(" "),
            _c("div", { staticClass: "customer-data__item" }, [
              _vm._v(_vm._s(_vm.customerDataDTO.email)),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "customer-data__item" }, [
              _vm._v(
                "\n      " +
                  _vm._s(_vm.customerDataDTO.street) +
                  "\n      " +
                  _vm._s(_vm.customerDataDTO.houseNr) +
                  "\n    "
              ),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "customer-data__item" }, [
              _vm._v(
                "\n      " +
                  _vm._s(_vm.customerDataDTO.zip) +
                  "\n      " +
                  _vm._s(_vm.customerDataDTO.city) +
                  "\n    "
              ),
            ]),
            _vm._v(" "),
            _vm.customerDataDTO.country
              ? [
                  _c("div", { staticClass: "customer-data__item" }, [
                    _vm._v(_vm._s(_vm.stateDisplay)),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "customer-data__item" }, [
                    _vm._v(_vm._s(_vm.countryDisplay)),
                  ]),
                ]
              : _vm._e(),
          ],
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }